import { get32BitIntegerCode } from "../../Hashing/utils/32BitIntegerCode";
import { RANDOM_COLOR_PALETTE } from "../constants/Color";

export const generateUniqueColorBasedOnKey = (key: string = "") => {
  return RANDOM_COLOR_PALETTE[
    get32BitIntegerCode(key) % RANDOM_COLOR_PALETTE.length
  ];
};
